import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";

import { getEnv } from "common/services";

export const envValue = getEnv();
export const envDatadogValue =
  envValue === "PROD" ? "prod" : envValue === "QA" || envValue === "PPRD" ? "qa" : "dev";

// Set REACT_APP_DISABLE_DATADOG=true in `.env` to skip RUM/Logs initialization entirely — useful
// locally when the Network tab gets noisy with `browser-intake-datadoghq.com` requests. Leave
// unset (or `false`) everywhere else so deployed environments keep full observability.
export const datadogDisabled = import.meta.env.REACT_APP_DISABLE_DATADOG === "true";

export const DD_RUM = () => {
  if (datadogDisabled) return;
  return datadogRum.init({
    applicationId: "f2e1e9cc-0730-4024-9bdc-dfdb8f609660",
    clientToken: "pub267d39adba1c5ce63f80fd50317b57b4",
    site: "datadoghq.com",
    env: envDatadogValue,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    service: "sales-quick-quote-web",
  });
};

export const DD_LOGS = () => {
  if (datadogDisabled) return;
  return datadogLogs.init({
    clientToken: "pub267d39adba1c5ce63f80fd50317b57b4",
    site: "datadoghq.com",
    env: envDatadogValue,
    sessionSampleRate: 100,
    forwardErrorsToLogs: true,
    service: "sales-quick-quote-web",
  });
};
